import { ProductSuggestion, ServiceSuggestion, SlicedSuggestions } from 'types/suggestions';

const MAX_SUGGESTIONS_NUMBER = 6;

export function getSlicedSuggestions(
  products: ProductSuggestion[],
  services: ServiceSuggestion[]
): SlicedSuggestions {
  const slicedProducts =
    services.length <= MAX_SUGGESTIONS_NUMBER / 2
      ? products.slice(0, MAX_SUGGESTIONS_NUMBER - services.length)
      : products.slice(0, MAX_SUGGESTIONS_NUMBER / 2);
  const slicedServices =
    products.length <= MAX_SUGGESTIONS_NUMBER / 2
      ? services.slice(0, MAX_SUGGESTIONS_NUMBER - products.length)
      : services.slice(0, MAX_SUGGESTIONS_NUMBER / 2);

  return [slicedProducts || [], slicedServices || []];
}
